<template>
    <v-app :style="setHeight" id="advertise-app">
        <v-carousel
            touchless
            :show-arrows="false"
            hide-delimiters
            hide-delimiter-background
            v-model="currentIndex"
            :cycle="cycle"
            interval="15000"
            height="40vh"
        >
            <v-carousel-item
                v-for="item in items"
                :key="item.id"
                v-html="item.content"
                transition="fade-transition"
                class="item"
                active-class="activeItem"
            >
            </v-carousel-item>
        </v-carousel>
    </v-app>
</template>

<script>
export default {
    data() {
        return {
            items: [],
            showVideo: true,
            showCarousel: false,
            currentIndex: '',
            cycle: true
        }
    },
    props: ['outlet'],
    computed: {
        currentItem() {
            return this.items[this.currentIndex]
        },
        setHeight() {
          return {
            height: '40vh',
          }
            const h = this.outlet.display_missed ? '90vh' : '100%'
            return {
                height: h,
            }
        }
    },
    watch: {
        currentItem(newVal, oldVal) {
            if (newVal.type === 'video') {
                this.cycle = false;
                setTimeout(() => this.playVideo(), 1000);
            }
        }
    },
    methods: {
        playVideo() {
            let videoCtrl = $('.activeItem').find('video');
            if (videoCtrl.length) {
                let video = videoCtrl[0];
                // video.load();
                video.muted = true;
                let playResult = video.play();
                if (playResult.catch && typeof playResult.catch === 'function') {
                  playResult.catch(function (error) {
                    // Disable Error Of "The play() request was interrupted because video-only background media was paused to save power. https://goo.gl/LdLk22"
                    // console.log(error.message)
                  });
                }

                video.onended = () => {
                    console.log('ended')
                    this.videoEnded()
                };

                video.onpause = () => {
                    console.log('paused')
                    this.videoEnded()
                };

                video.onsuspend = () => {
                    video.oncanplay = () => {
                        video.play()
                    }
                };

                video.onerror = () => {
                    console.log('error')
                    this.videoEnded()
                };

                video.onstalled = () => {
                    console.log('stalled')
                    this.videoEnded()
                };
            }
        },
        videoEnded() {
            this.cycle = true;
            // if only got video, replay video
            if (!this.outlet.ads) {
                this.playVideo();
            }
        }
    },
    beforeMount() {
        if (this.outlet.ads && JSON.parse(this.outlet.ads).length > 0) {
            let i;
            for (i = 0; i < JSON.parse(this.outlet.ads).length; i++) {
                this.items.push(
                    {
                        id: this.items.length + 1,
                        content: '<img alt="Advertise Image" style="width: 100%; height: 40vh" src="https://qms.aptsys.com.sg/storage' + JSON.parse(this.outlet.ads)[i] + '" />',
                        type: 'img'
                    }
                );
            }
        }
        if (this.outlet.video) {
            this.items.push(
                {
                    id: this.items.length + 1,
                    content: '<video style="object-fit: fill; width: 100%; height: 40vh" id="video" src="https://qms.aptsys.com.sg/storage' + this.outlet.video + '" muted>',
                    type: 'video'
                }
            );
        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/VerticalAdvertise.vue